<span
  class="tag is-info is-light"
  class:is-medium={!isLarge}
  class:is-large={isLarge}
  style="white-space: pre-wrap; height: fit-content; padding: 0.25rem 0.75rem"
  ><span class="icon">
    <i class="mdi mdi-message-text" />
  </span>&nbsp;<span>
    <slot />
  </span>
</span>

<script lang="ts">
  export let isLarge = false;
</script>
